import { makeAutoObservable } from "mobx";
import { Subject } from "rxjs";
import { CountryWithStateModel } from "../models/CountryModels";
import CountryService from "../services/CountryService";

export default class CountryStore {
  public countriesWithState: CountryWithStateModel[] = [];
  public onCountryDataLoaded = new Subject<CountryWithStateModel[]>();
  constructor() {
    makeAutoObservable(this);

    CountryService.getCountriesWithState().subscribe((response) => {
      this.countriesWithState = response.result.map(
        (c) => new CountryWithStateModel(c)
      );
      this.onCountryDataLoaded.next(this.countriesWithState);
    });
  }

  getUSCountry() {
    return this.countriesWithState.find((c) => c.abbreviationName === "US");
  }

  getCountriesWithState() {
    return this.countriesWithState;
  }

  sortCountriesByName = () => {
    return this.countriesWithState
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name));
  };
}
